<template>
  <div class="form-group">
    <label v-if="label">{{ label }}</label>
    <input
      :value="value"
      v-on="listeners"
      @input="updateValue"
      v-bind="$attrs"
      class="form-control"
    />
  </div>
</template>

<script>
import { formFieldMixin } from '@/mixins/formFieldMixin'

export default {
  mixins: [formFieldMixin],
  computed: {
    listeners() {
      return {
        ...this.$listeners,
        input: this.updateValue
      }
    }
  }
}
</script>

<style scoped>
.form-control {
  background: none;
}
</style>
